<!--样式引入-->
<style scoped lang="scss" src="./index.scss"></style>

<!--模版引入-->
<template lang="pug" src="./index.pug"></template>

<script>
import { mapState } from "vuex";
import wlArticle from "@/components/wl-article";
export default {
  components: {wlArticle},
  data() {
    return {
      tbNav: 1,   //1-发布 2-评论 3-粉丝 4-获赞

      RefreshLoading: false, //刷新
      Loading: false,      //加载
      Finished: false,      //加载完成
      List: [],
      pagination:{
        index: 0,
        pages: 0,
        size: 20,
        total: 0,
      },
    };
  },
  computed: {
    ...mapState(['userInfo','authToken','user_title']),
    emptyMsg(){
      if(this.tbNav===1){
        return '您当前暂无文章';
      }else if(this.tbNav===2){
        return '您还未收到任何评论'
      }else if(this.tbNav===3){
        return '您当前暂无粉丝'
      }else if(this.tbNav===4){
        return '您当前暂无获赞'
      }
    },
  },
  watch: {
    
  },
  created: function() {
  },
  mounted: function() {
    
  },
  methods: {
     //切换标签
    changeTab(tbNav){
      this.tbNav = tbNav;
      this.refreshList();
    },
    //刷新列表
    refreshList() {
      this.Loading = true;
      this.Finished = false;
      this.pagination.index = 0;
      this.List = [];
      this.loadList().then(res=>{
        this.RefreshLoading = false;
      })
    },
    //加载列表
    loadList() {
      // 异步更新数据
      var params = {
        pagination: {
          index: this.pagination.index + 1,
          size: this.pagination.size,
        }
      };
      var _this = this;
      return new Promise((resolve,reject)=>{
        var API;
        if(_this.tbNav==1){
          //发布的文章
          API = 'myArticlePage';
          params.sort = [{code:"publishDtm",desc:true}];
        }else if(_this.tbNav == 2){
          //收到的评论
          API = 'myArticleReplyPage';
          params.sort = [{code:"ut",desc:true}];
        }else if(_this.tbNav == 3){
          //粉丝
          API = 'myFansPage';
          params.sort = [{code:"ut",desc:true}];
        }else if(_this.tbNav == 4){
          //点赞
          API = 'myThumbupPage';
          params.sort = [{code:"ut",desc:true}];
        }
        console.log(API);
        _this.$api[API](params).then(res=>{
          var data = res.data;
          var list = data.data || [];
          list.map(r=>{
            if(r.imgs){
              r.imgs = JSON.parse(r.imgs);
            }else{
              r.imgs = [];
            }
            return r;
          })
          if(data.pagination.index===1){
            _this.List = list;
          }else{
            _this.List = _this.List.concat(list);
          }
          _this.pagination = data.pagination;
          // 数据全部加载完成
          if (_this.List.length >= _this.pagination.total) {
            _this.Finished = true;
          }
          // 加载状态结束
          _this.Loading = false;
          resolve();
        });
      })
      
    },
  }
};
</script>



// WEBPACK FOOTER //
// src/pages/mine/index.vue